import { faCode } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import { useDonationFormBuilder } from './useDonationFormBuilder';

function DonationFormEmbedButton(): JSX.Element {
  const { t } = useTranslation();
  const { openEmbedModal } = useDonationFormBuilder();

  return (
    <Button onClick={openEmbedModal} prefix={<FontAwesomeIcon icon={faCode} />} type={'secondary'}>
      {t('Embed')}
    </Button>
  );
}

export default DonationFormEmbedButton;
